module.exports = __webpack_public_path__ + "static/media/restaurant8.828bb54b.jpg";